function getRootDomain(hostname: string): string {
  const parts = hostname.split('.').filter(Boolean);
  return parts.length >= 2 ? parts.slice(-2).join('.') : hostname;
}

export function getSupportUrl(): string {
  const { hostname, protocol } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1')
    return process.env.REACT_APP_SUPPORT_URL || 'http://localhost:3004';

  return `${protocol}//support.${getRootDomain(hostname)}`;
}

export const supportUrl = getSupportUrl();
